module.exports = {
      id: "double-arrow-usage",
      viewBox: "0 0 21.133 19.508",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#double-arrow",
      toString: function () {
        return this.url;
      }
    }